import {isMobile} from "~/lib/helpers";

const VueIsMobile = {
  install(Vue) {
    Vue.prototype.$isMobile = function $isMobile( event:string, ...args:unknown[]) {
      return isMobile();
    };
  }
};

export {VueIsMobile} ;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-22234671/vue-is-mobile.tsx" });